export const columns = [
    { field: 'pageTitle', headerName: 'Название товара', flex: 1.5, minWidth: 200 },
    {
      field: 'number',
      eventCount: 'Телефон',
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'mail',
      headerName: 'Почта',
      headerAlign: 'right',
      align: 'right',
      flex: 1,
      minWidth: 100,
    }
  ];

export const rows = [
    {
        id: 1,
        pageTitle: 'Вадим',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 2,
        pageTitle: 'Павел',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 3,
        pageTitle: 'Назар',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 4,
        pageTitle: 'Олег',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 5,
        pageTitle: 'Артем',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 6,
        pageTitle: 'Сергей',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 7,
        pageTitle: 'Павел',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 8,
        pageTitle: 'Андрей',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 9,
        pageTitle: 'Роман',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 10,
        pageTitle: 'Светлана',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 11,
        pageTitle: 'Матвей',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 12,
        pageTitle: 'Артемий',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 13,
        pageTitle: 'Владилен',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
      {
        id: 14,
        pageTitle: 'Михаил',
        number: '8(888)172-23-54',
        mail: 'example@mail.ru',
      },
]